import * as yup from 'yup'

export class NeedsClusterRemovedPulledClusterPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    clusterPhotosPulledClusterPhotoFile?: File = undefined
  clusterPhotosPulledClusterPhotoNote?: string = undefined
}

export const needsClusterRemovedPulledClusterPhotoValidationSchema = yup.object().shape({
    clusterPhotosPulledClusterPhotoNote: yup
    .string()
    .nullable()
    .max(200, 'Pulled Cluster Photo Note cannot be more than 200 characters.')
})
